
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { HelpInfoMixin, BAIconsMixin, StringsMixin } from '@/mixins';

@Component
export default class HelpInfo extends Mixins(HelpInfoMixin, BAIconsMixin, StringsMixin){
    @Prop({ type: Boolean }) noicon: boolean;
    @Prop() icon: string;
    @Prop() preText: string;
    @Prop() postText: string;
    @Prop() linkText: string;
    @Prop({ default: "Hide Help" }) helpText: string;

    get Icon(): string {
        if( this.IsNotEmpty(this.icon) ) return this.icon;
        return this.BAIcons.help;
    }
}
